/* PERF: façade pattern for hero/background videos.
   - Poster <img> renders with fetchpriority=high (acts as LCP).
   - <video> renders with preload=none + autoplay=false.
   - After window.load + requestIdleCallback, this script promotes the video to play().
   - On 'playing' event, the poster image is faded out via the .is-playing class.
   This keeps LCP < 2s while preserving the autoplay UX a beat after first paint. */
if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(
          ".hero--video-background",
        );
        if (this.video_section) {
          this.checkAndPlayVideoSection(this.video_section);
        } else if (this.video_background_section) {
          this.checkAndPlayBackgroundVideoSection(
            this.video_background_section,
          );
        }
        this.setupFacadePromotion();
      }

      /* PERF: promote façade'd hero videos to autoplay after load + idle */
      setupFacadePromotion() {
        const facades = this.querySelectorAll(
          "[data-hero-video-facade][data-autoplay-after-load]",
        );
        if (!facades.length) return;
        const ric =
          window.requestIdleCallback ||
          function (cb) {
            return setTimeout(cb, 1);
          };
        const promote = () => {
          ric(() => {
            facades.forEach((facade) => {
              const video = facade.querySelector("video");
              if (!video) return;
              const poster = facade.querySelector("[data-hero-video-poster]");
              const onPlaying = () => {
                facade.classList.add("is-playing");
                if (poster) poster.style.opacity = "0";
                video.removeEventListener("playing", onPlaying);
              };
              video.addEventListener("playing", onPlaying);
              try {
                video.load();
                const p = video.play();
                if (p && typeof p.catch === "function") p.catch(() => {});
              } catch (_) {}
            });
          });
        };
        if (document.readyState === "complete") {
          promote();
        } else {
          window.addEventListener("load", promote, { once: true });
        }
      }

      checkAndPlayBackgroundVideoSection(video_background_section) {
        const hero_overlay =
          video_background_section.querySelector(".hero__overlay");
        const video_element = video_background_section.querySelector("video");
        if (video_element) {
          hero_overlay.addEventListener("touchstart", () =>
            this.playVideo(video_element),
          );
          hero_overlay.addEventListener("click", () =>
            this.playVideo(video_element),
          );
        }
      }

      checkAndPlayVideoSection(video) {
        const video_element = video.querySelector("video");
        if (video_element) {
          video.addEventListener("touchstart", () =>
            this.playVideo(video_element),
          );
          video.addEventListener("click", () => this.playVideo(video_element));
        }
      }

      playVideo(video_element) {
        if (!video_element.playing) {
          video_element.play();
        }
      }

      disconnectedCallback() {
        if (this.video_section) {
          this.video_section.removeEventListener("touchstart", this.playVideo);
          this.video_section.removeEventListener("click", this.playVideo);
        }
        if (this.video_background_section) {
          const hero_overlay =
            this.video_background_section.querySelector(".hero__overlay");
          const video_element =
            this.video_background_section.querySelector("video");
          if (video_element) {
            hero_overlay.removeEventListener("touchstart", () =>
              this.playVideo(video_element),
            );
            hero_overlay.removeEventListener("click", () =>
              this.playVideo(video_element),
            );
          }
        }
      }
    },
  );
}
